<template>
  <div class="legal-container">
    <h1>Termos de Uso – Zinnes</h1>
    <p><strong>Data de Vigência: 17/05/2025</strong></p>

    <h2>1. Definições</h2>
    <p>Para os fins destes Termos de Uso, as seguintes definições se aplicam:</p>
    <ul>
      <li><strong>Plataforma:</strong> Refere-se ao site, aplicativo e todos os serviços oferecidos pela Zinnes, acessíveis em <a href="https://www.zinnes.com.br">www.zinnes.com.br</a>.</li>
      <li><strong>Usuário:</strong> Qualquer pessoa física ou jurídica que acesse, utilize ou interaja com a Plataforma.</li>
      <li><strong>Conteúdo:</strong> Todos os materiais, incluindo quadrinhos, mangás, webcomics, textos, imagens, vídeos, comentários e outras criações publicadas na Plataforma.</li>
      <li><strong>Conta:</strong> Perfil criado pelo Usuário na Plataforma para acessar funcionalidades específicas.</li>
    </ul>

    <h2>2. Aceitação dos Termos</h2>
    <p>Bem-vindo à Zinnes, uma plataforma digital para leitura e publicação de quadrinhos. Ao acessar ou utilizar a plataforma, você concorda em cumprir
      estes Termos de Uso. Caso não concorde com qualquer parte destes termos, não utilize nossos serviços.</p>

    <h2>3. Idade Mínima e Capacidade</h2>
    <p>A Zinnes não é destinada a menores de 13 anos. Menores de 18 anos só podem utilizar a plataforma com o consentimento e supervisão de um responsável legal. Ao utilizar a plataforma, você declara e garante que:</p>
    <ul>
      <li>Possui pelo menos 13 anos de idade.</li>
      <li>Se menor de 18 anos, possui o consentimento de seu responsável legal para utilizar a plataforma.</li>
      <li>Tem capacidade legal para celebrar estes Termos de Uso.</li>
    </ul>

    <h2>4. Descrição do Serviço</h2>
    <p>A Zinnes é uma plataforma que permite aos usuários ler, publicar e interagir com quadrinhos, mangás, webcomics e
      outros conteúdos criativos. Oferecemos funcionalidades como criação de contas, publicação de conteúdos, leitura
      personalizada e transações financeiras para compras ou doações.</p>
    <p><strong>Anúncios:</strong> A plataforma pode incluir anúncios fornecidos por terceiros, como o Google AdSense. Esses terceiros podem usar cookies e tecnologias de rastreamento para personalizar anúncios conforme descrito em nossa <a href="https://www.zinnes.com.br/politica-de-privacidade">Política de Privacidade</a>.</p>

    <h2>5. Cadastro e Conta</h2>
    <p>Para acessar certas funcionalidades, como publicar quadrinhos ou realizar transações, você deve criar uma conta
      fornecendo informações verdadeiras e precisas, como nome, e-mail e senha. Você é responsável por:</p>
    <ul>
      <li>Manter a confidencialidade de suas credenciais de acesso.</li>
      <li>Todas as atividades realizadas em sua conta.</li>
      <li>Notificar a Zinnes imediatamente em caso de uso não autorizado de sua conta.</li>
    </ul>
    <p>A Zinnes reserva-se o direito de suspender ou encerrar contas que violem estes termos.</p>

    <h2>6. Direitos Autorais e Propriedade Intelectual</h2>
    <p>Todo conteúdo publicado na Zinnes, incluindo quadrinhos, textos, imagens e outros materiais, é de
      responsabilidade de seus respectivos autores. Ao publicar conteúdo, você garante que:</p>
    <ul>
      <li>Possui todos os direitos necessários para publicar o conteúdo.</li>
      <li>O conteúdo não infringe direitos autorais, marcas registradas ou outros direitos de terceiros.</li>
    </ul>
    <p><strong>Licença Concedida:</strong> Você concede à Zinnes uma licença mundial, não exclusiva, transferível e isenta de royalties para exibir,
      distribuir e promover seu conteúdo na plataforma, exclusivamente para os fins de operação e promoção da Zinnes.</p>
    <p><strong>Remoção de Conteúdo:</strong> Você pode remover seu conteúdo publicado a qualquer momento. No entanto, a licença concedida pode persistir para backups, materiais de marketing já produzidos ou conforme necessário para operação da plataforma.</p>
    <p><strong>Uso Promocional:</strong> A Zinnes pode usar imagens, trechos ou amostras do seu conteúdo para divulgação da plataforma, incluindo redes sociais, materiais promocionais e marketing.</p>
    <p><strong>Proteção da Marca Zinnes:</strong> Logotipos, marcas, design e outros elementos visuais da Zinnes são protegidos por direitos autorais e marcas registradas. É expressamente proibido:</p>
    <ul>
      <li>Realizar engenharia reversa da plataforma.</li>
      <li>Executar scraping massivo ou coleta automatizada de dados.</li>
      <li>Usar comercialmente elementos da Zinnes sem autorização expressa.</li>
    </ul>
    <p>O conteúdo da plataforma (exceto o conteúdo dos usuários) é protegido por direitos autorais e pertence à Zinnes
      ou a seus licenciadores. Você não pode reproduzir, modificar ou distribuir esse conteúdo sem autorização expressa.
    </p>

    <h2>7. Conduta do Usuário</h2>
    <p>Ao usar a Zinnes, você concorda em não:</p>
    <ul>
      <li>Publicar ou compartilhar conteúdo ofensivo, discriminatório, difamatório, obsceno, ilegal ou que viole os
        direitos de terceiros.</li>
      <li>Utilizar a plataforma para fins ilícitos, como distribuição de malware, phishing ou outras atividades
        maliciosas.</li>
      <li>Violar direitos de propriedade intelectual, incluindo o uso não autorizado de quadrinhos, imagens ou textos.
      </li>
      <li>Interferir no funcionamento da plataforma, como ataques cibernéticos ou tentativas de acessar áreas restritas.
      </li>
      <li>Usar bots, scripts ou outros meios automatizados para acessar ou interagir com a plataforma sem permissão.
      </li>
    </ul>
    <p>A Zinnes pode remover conteúdo ou suspender contas que violem estas regras, a seu critério.</p>

    <h2>8. Moderação de Conteúdo</h2>
    <p>A Zinnes reserva-se o direito de revisar, moderar, remover ou bloquear conteúdo que viole estes Termos de Uso, a
      Política de Privacidade ou a legislação aplicável, sem aviso prévio.</p>

    <h2>9. Transações Financeiras</h2>
    <p>A Zinnes pode oferecer funcionalidades de compra, assinatura ou doação, processadas por prestadores de serviços
      de pagamento terceirizados em ambiente seguro. Você concorda em fornecer informações precisas para essas transações e cumprir os
      termos dos provedores de pagamento.</p>
    <p><strong>Segurança:</strong> Os pagamentos são processados em ambiente seguro de terceiros especializados. A Zinnes não armazena dados de cartão de crédito ou informações financeiras sensíveis.</p>
    <p><strong>Reembolsos:</strong> Políticas de reembolso seguem as diretrizes do provedor de pagamento utilizado. Para solicitar reembolsos, entre em contato conosco através dos canais oficiais.</p>

    <h2>10. Isenção de Responsabilidade</h2>
    <p>A Zinnes não se responsabiliza por:</p>
    <ul>
      <li>Danos diretos, indiretos, incidentais ou consequenciais decorrentes do uso ou impossibilidade de uso da
        plataforma.</li>
      <li>Erros, omissões ou imprecisões no conteúdo publicado por usuários.</li>
      <li>Perdas de dados, interrupções de serviço ou falhas técnicas fora de nosso controle.</li>
      <li>Disponibilidade ou continuidade dos serviços, que podem ser interrompidos para manutenção ou atualizações.</li>
    </ul>
    <p>A plataforma é fornecida "no estado em que se encontra", sem garantias de qualquer tipo, exceto conforme exigido
      por lei. Não há garantia de disponibilidade, continuidade ou ausência de erros nos serviços.</p>
    <p><strong>Limitação de Responsabilidade:</strong> A responsabilidade máxima da Zinnes, quando aplicável, será limitada ao valor pago pelo usuário pelos serviços nos últimos 12 meses, conforme permitido pela legislação brasileira.</p>

    <h2>11. Modificações nos Termos de Uso</h2>
    <p>A Zinnes pode atualizar estes Termos de Uso a qualquer momento. A versão mais recente estará disponível em <a
        href="https://www.zinnes.com.br/termos-de-uso">https://www.zinnes.com.br/termos-de-uso</a>.</p>
    <p><strong>Notificação de Mudanças:</strong> Em caso de mudanças relevantes, notificaremos os usuários através de aviso na plataforma ou por e-mail antes da entrada em vigor das alterações. O uso contínuo da plataforma após as alterações constitui aceitação dos novos termos.</p>

    <h2>12. Rescisão</h2>
    <p>A Zinnes pode suspender ou encerrar sua conta, sem aviso prévio, se você violar estes Termos de Uso, a Política
      de Privacidade ou a legislação aplicável. Você pode encerrar sua conta a qualquer momento, sujeito às condições de
      exclusão descritas na <a href="https://www.zinnes.com.br/politica-de-privacidade">Política de Privacidade</a>.</p>

    <h2>13. Sobre Nós</h2>
    <p>A Zinnes é uma plataforma apaixonada por quadrinhos, criada para conectar autores e leitores em um ambiente
      criativo e inovador. Nossa equipe é composta por:</p>
    <ul>
      <li><strong>Andy Ichigo:</strong> Artista de mangá e quadrinhos de São Paulo, SP, reconhecido pela one-shot “My
        World”, vencedora do 5º Concurso de Mangás do Estúdio Armon. Trabalhou com editoras underground e independentes,
        como Aquele Velho Mar, Syncro e Amor Sismico.</li>
      <li><strong>Felipe Lee:</strong> Diretor e sócio fundador da Zinnes, com quase 10 anos de experiência em
        gerenciamento de projetos, storyboard e edição de filmes. Apaixonado por quadrinhos, também é autor e animador
        nas horas vagas.</li>
      <li><strong>Fernando:</strong> Quadrinista há 15 anos, criou obras como TDF, A Experiência, Syncro I e Potric.
        Apaixonado por criar mundos e personagens que emocionam e inspiram os leitores.</li>
      <li><strong>Guilherme:</strong> Escritor, roteirista e diretor da Zinnes, cuida das relações públicas e participa
        da construção de projetos. Autor de Karma, Agatha e o Reino Sombrio, Rei do Norte e Tribos.</li>
    </ul>

    <h2>14. Lei Aplicável e Resolução de Disputas</h2>
    <p>Estes Termos de Uso são regidos pelas leis da República do Brasil. Qualquer disputa relacionada a estes termos
      será resolvida nos tribunais competentes da cidade de São Paulo, SP, salvo disposição legal em contrário.</p>

    <h2>15. Política de Privacidade</h2>
    <p>O uso da plataforma também está sujeito à nossa <a href="https://www.zinnes.com.br/politica-de-privacidade">Política de Privacidade</a>, que descreve como coletamos, usamos e protegemos suas informações. Em caso de conflito entre estes Termos de Uso e a Política de Privacidade, prevalecerá o documento mais específico à situação em questão.</p>

    <h2>16. Contato</h2>
    <p>Para dúvidas sobre estes Termos de Uso, entre em contato:</p>
    <p><strong>E-mail:</strong> <a href="mailto:suporte.zinnes@gmail.com">suporte.zinnes@gmail.com</a><br>
      <strong>Formulário de Contato:</strong> Disponível em <a href="https://www.zinnes.com.br/contato">https://www.zinnes.com.br/contato</a><br>
      <strong>CNPJ:</strong> 52.230.302/0001-50
    </p>

    <div class="footer">
      <p>Zinnes – Sua plataforma de quadrinhos!</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TermsOfUse',
}
</script>

<style scoped>
.legal-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem 2rem;
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
  background-color: #fff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}

h1 {
  color: #631b8d;
  text-align: center;
  margin-bottom: 1.5rem;
}

h2 {
  color: #631b8d;
  margin-top: 2rem;
}

p,
li {
  margin-bottom: 1rem;
}

ul {
  list-style-type: disc;
  margin-left: 2rem;
}

a {
  color: #631b8d;
  text-decoration: none;
}

a:hover {
  text-decoration: underline;
}

.footer {
  text-align: center;
  margin-top: 2rem;
  font-size: 0.9rem;
  color: #666;
}

@media (max-width: 600px) {
  .legal-container {
    padding: 1rem;
  }
}
</style>
